import React from 'react';
import ProductItemView from '../ProductItemView';
import news from '../../resource/lis/news.svg';

const News = () => {
    return (
        <ProductItemView
            title="Novedades"
            items={["Tablero de control gerencial en tiempo real",
                "Módulo de caja con soporte para pago con billeteras electrónicas QR",
                "Mecanismo de notificaciones, alertas y comunicaciones internas integrado",
                "Envío de resultados por correo y whatsapp"]}
            image={news} />
    );
};

export default News;